import { render } from "./ReservationsCompletedPage.vue?vue&type=template&id=4453366c&ts=true"
import script from "./ReservationsCompletedPage.vue?vue&type=script&lang=ts"
export * from "./ReservationsCompletedPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Proyectos\\mytransfers-extranet-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__